import { render, staticRenderFns } from "./GitDiffHighlighter.vue?vue&type=template&id=36c82638&scoped=true&"
import script from "./GitDiffHighlighter.vue?vue&type=script&lang=ts&"
export * from "./GitDiffHighlighter.vue?vue&type=script&lang=ts&"
import style0 from "./GitDiffHighlighter.vue?vue&type=style&index=0&id=36c82638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c82638",
  null
  
)

export default component.exports